import { createFileRoute } from "@tanstack/react-router";
import { AvtalePeriodePage } from "@/features/bestillinger/pages/AvtalePeriodePage";

export const Route = createFileRoute("/_app/bestilling/ny/periode/")({
  component: AvtalePeriodePage,
  head: () => ({
    meta: [
      {
        title: "Velg avtaleperiode | Norgespris for Fjernvarme",
      },
    ],
  }),
});
